/**
 * SoleadLab 2.0 — IV Panel (Floating Overlay)
 *
 * Full-screen overlay (like CalculatorPanel / TasksPanel) that hosts
 * the IV session detail workspace: Import → Measurements → Analysis → Report.
 */

import { useIVStore } from '@/stores/ivStore';
import IVSessionDetail from './IVSessionDetail';

interface IVPanelProps {
  onClose: () => void;
}

export default function IVPanel({ onClose }: IVPanelProps) {
  const sessions = useIVStore((s) => s.sessions);
  const selectedSessionId = useIVStore((s) => s.selectedSessionId);
  const session = sessions.find((s) => s.id === selectedSessionId);

  return (
    <div className="iv-panel-overlay" onClick={onClose}>
      <div className="iv-panel-container" onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div className="iv-panel-header">
          <div className="iv-panel-header__left">
            {/* IV curve icon */}
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="2 20 6 10 10 14 14 6 18 12 22 4" />
            </svg>
            <span className="iv-panel-title">IV Curve Analysis</span>
            {session && (
              <span className={`iv-badge iv-badge--${session.status}`} style={{ marginLeft: 8 }}>
                {session.status}
              </span>
            )}
          </div>
          <button className="iv-panel-close" onClick={onClose} title="Close">×</button>
        </div>

        {/* Body — full IVSessionDetail */}
        <div className="iv-panel-body">
          <IVSessionDetail />
        </div>

      </div>
    </div>
  );
}
